module.exports = __webpack_public_path__ + "static/workpad-771f24decddad66bbe238bdbface5873.jpg";